export default __webpack_public_path__ + "static/media/POPPINS-EXTRALIGHT.9daa4ad4.TTF";